import { Injectable } from '@angular/core';
import { CanActivate, Router } from '@angular/router';
import { AuthService } from '../services/auth.service';

@Injectable({
  providedIn: 'root'
})
export class UserGuard implements CanActivate {

  constructor(
    private authService: AuthService,
    private router: Router
  ) {}

  canActivate(): boolean {
    // Проверяем авторизацию
    if (!this.authService.isAuthenticated()) {
      this.router.navigate(['/login']);
      return false;
    }

    // // Проверяем данные пользователя из authService
    // const userProfile = this.authService.getUserProfile();
    // if (!userProfile || !userProfile.id) {
    //   // Если нет профиля или id - отправляем на login
    //   this.router.navigate(['/login']);
    //   return false;
    // }

    // // Проверяем данные пользователя из localStorage
    // const userData = this.authService.getUserProfileFromLocalStorage();
    // if (!userData) {
    //   // Если нет - отправляем на загрузку профиля
    //   this.router.navigate(['/profile']);
    //   return false;
    // }

    // if (!userData.id || userData.id != userProfile.id) {
    //   // Если id не совпадают или отсутствуют - отправляем на загрузку профиля
    //   this.router.navigate(['/profile']);
    //   return false;
    // }
    
    return true;
  }
}